import { jsx } from 'react/jsx-runtime';
import { useResourceListPreferencesContext } from '../../ResourceList/contexts/resourceListContextPreferences.js';
import { IconMobileSheet24KindAll, IconMobileSheet24KindFile, IconMobileSheet24KindEmail, IconMobileSheet24KindNotepad, IconMobileSheet24KindFolder, IconMobileSheet24KindHighlight, IconMobileSheet24KindBookmark, IconMobileSheet24KindVideo, IconMobileSheet24KindAudio, IconMobileSheet24KindImage, IconMobileSheet24KindDocument, IconDropdown14All } from '@fabric-app/icons/svg';
import { MultiSelect } from '@fabric-app/ui/components/MultiSelect/MultiSelect';
import { Kind } from '@fabric/woody-client';

const kindDisplayValue = (kind) => {
  switch (kind) {
    case Kind.DEFAULT_FILE:
      return "Other";
    case Kind.DOCUMENT:
      return "Document";
    case Kind.IMAGE:
      return "Image";
    case Kind.AUDIO:
      return "Audio";
    case Kind.VIDEO:
      return "Video";
    case Kind.BOOKMARK:
      return "Bookmark";
    case Kind.HIGHLIGHT:
      return "Highlight";
    case Kind.FOLDER:
      return "Folder";
    case Kind.NOTEPAD:
      return "Note";
    case Kind.EMAIL:
      return "Email";
    default:
      return kind;
  }
};
const iconComponent = (kind) => {
  switch (kind) {
    case Kind.DEFAULT_FILE:
      return IconMobileSheet24KindAll;
    case Kind.DOCUMENT:
      return IconMobileSheet24KindDocument;
    case Kind.IMAGE:
      return IconMobileSheet24KindImage;
    case Kind.AUDIO:
      return IconMobileSheet24KindAudio;
    case Kind.VIDEO:
      return IconMobileSheet24KindVideo;
    case Kind.BOOKMARK:
      return IconMobileSheet24KindBookmark;
    case Kind.HIGHLIGHT:
      return IconMobileSheet24KindHighlight;
    case Kind.FOLDER:
      return IconMobileSheet24KindFolder;
    case Kind.NOTEPAD:
      return IconMobileSheet24KindNotepad;
    case Kind.EMAIL:
      return IconMobileSheet24KindEmail;
    default:
      return IconMobileSheet24KindFile;
  }
};
const kinds = [
  Kind.IMAGE,
  Kind.NOTEPAD,
  Kind.BOOKMARK,
  Kind.HIGHLIGHT,
  Kind.DOCUMENT,
  Kind.DEFAULT_FILE,
  Kind.FOLDER,
  Kind.AUDIO,
  Kind.VIDEO,
  Kind.EMAIL
];
const defaultValue = [];
const filterKindOptions = [
  {
    value: "placeholder",
    label: "Any kind",
    stringLabel: "Any kind",
    icon: /* @__PURE__ */ jsx(IconMobileSheet24KindAll, {})
  },
  ...kinds.filter((kind) => kind !== Kind.PERSON).map((kind) => {
    const Icon = iconComponent(kind);
    return {
      value: kind,
      label: kindDisplayValue(kind),
      stringLabel: kindDisplayValue(kind),
      icon: /* @__PURE__ */ jsx(Icon, {})
    };
  })
];
const ResourceFilterKind = ({ disabled = false }) => {
  const { filters, setFilterKind } = useResourceListPreferencesContext();
  const value = filters.kind || defaultValue;
  return /* @__PURE__ */ jsx(MultiSelect, {
    title: "Filter by kind...",
    trigger: {
      icon: /* @__PURE__ */ jsx(IconDropdown14All, {}),
      emptyLabel: "Any kind",
      testId: "filters-kind-button",
      disabled
    },
    options: filterKindOptions,
    value,
    onValueChange: setFilterKind
  });
};

export { ResourceFilterKind, filterKindOptions };
//# sourceMappingURL=ResourceFilterKind.js.map
